module.exports = __webpack_public_path__ + "static/media/right.bd17ab17.svg";